import { render, staticRenderFns } from "./classical-calendar.vue?vue&type=template&id=30d6fb9a&scoped=true"
import script from "./classical-calendar.vue?vue&type=script&lang=js"
export * from "./classical-calendar.vue?vue&type=script&lang=js"
import style0 from "./classical-calendar.vue?vue&type=style&index=0&id=30d6fb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6fb9a",
  null
  
)

export default component.exports